import Model, { attr, belongsTo } from '@ember-data/model';
import type QuestionnaireResponse from 'garaje/models/questionnaire-response';
import type SignInField from 'garaje/models/sign-in-field';

export default class QuestionnaireFieldResponse extends Model {
  @belongsTo('questionnaire-response', { async: false, inverse: null })
  declare questionnaireResponse: QuestionnaireResponse;

  @belongsTo('sign-in-field', { async: false, inverse: null })
  declare signInField: SignInField;

  @attr('boolean') declare isCorrect: boolean;
  @attr('string') declare responseValue: string;
  @attr('array') declare selectedOptionIds: string[];
}
